<template><div><h1 id="anlassspendeauswertung" tabindex="-1"><a class="header-anchor" href="#anlassspendeauswertung"><span>Anlassspendeauswertung</span></a></h1>
<p>Anlassspendeauswertung — &quot;Beschreibung&quot;</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Um die Anzahl Responses und Wert der Responses pro Anlassart zu ermitteln ist diese Standardauswertung implementiert worden.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Anlassspendenauswertung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>Anlassart:
:</p>
</li>
<li>
<p>Datum von :
: inklusive, leer = unbegrenzt</p>
</li>
<li>
<p>Datum bis:
:</p>
</li>
<li>
<p>Verarbeitungszeitpunkt:
:</p>
</li>
</ul>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-portrait)</dd>
<dt>- Bildschirm</dt>
<dd>
<ul>
<li>Bildschirm</li>
</ul>
</dd>
<dt>- Drucker:</dt>
<dd>A4 hoch</dd>
<dt>- Textdatei:</dt>
<dd>Text</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder:</td>
<td>Rekapitulation der gewählten Parameter</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Art:</td>
<td></td>
</tr>
<tr>
<td>- Anzahl:</td>
<td></td>
</tr>
<tr>
<td>- Wert:</td>
<td></td>
</tr>
<tr>
<td>- Beschreibung:</td>
<td></td>
</tr>
</tbody>
</table>
<p>--</p>
<p>Lesebeispiel: -</p>
</div></template>


